// extracted by mini-css-extract-plugin
export default {"toc":"K_b0","h3toc":"K_b1","linkText":"K_b2","tocTitle":"K_b3"};